export const EFltPnrGroupType = {
   0: "UNKNOWN",
   1: "SPORTS",
   2: "TENDER",
   3: "STUDENT",
   4: "HAJJ",
   5: "UMRAH",
   6: "MEETING",
   7: "MICE",
   8: "DEALER",
   9: "HOLIDAY_PACKAGE",
   10: "OTHER",
   "-1": "ALL",
};
